import axios from "axios";
import { setAuthToken } from "../utils/helper";
import jwt_decode from "jwt-decode";
import Cookies from 'js-cookie';
import { GET_ERRORS, SET_CURRENT_USER, USER_LOADING } from "./actiontypes";

const env = process.env.NODE_ENV || 'development';
const config = require('../config.json')[env];
const btoa = require('btoa');
const basicAuth = 'Basic ' + btoa(config.api_credentials);

const instance = axios.create({
  baseURL: config.main_server,
  timeout: 8000,
  headers: {
    'content-type': 'application/json',
    'auth': basicAuth,
  },
});

// // Register User
// export const registerUser = (userData, history) => dispatch => {
//   axios
//     .post("/api/users/register", userData)
//     .then(res => history.push("/admin/login"))
//     .catch(err =>
//       dispatch({
//         type: GET_ERRORS,
//         payload: err.response.data
//       })
//     );
// };

// Login - get user token
export const login = userData => dispatch => {
  instance
    .post("/api/user/login", userData)
    .then(res => {
      // Save to localStorage

      // Set token to localStorage
      const { token } = res.data;
      localStorage.setItem("jwtToken", token);
      Cookies.set("token", token)
      // Set token to Auth header
      setAuthToken(token);
      // Decode token to get user data
      const decoded = jwt_decode(token);
      // Set current user
      dispatch(setCurrentUser(decoded));
    })
    .catch(err =>
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data
      })
    );
};

// Set logged in user
export const setCurrentUser = decoded => {
  return {
    type: SET_CURRENT_USER,
    payload: decoded
  };
};

// User loading
export const setUserLoading = () => {
  return {
    type: USER_LOADING
  };
};

// Log user out
export const logoutUser = () => dispatch => {
  // Remove token from local storage
  if (typeof localStorage !== "undefined") {
    localStorage.removeItem("jwtToken");
  }
  Cookies.remove('token');
  Cookies.remove('accessToken');
  // Remove auth header for future requests
  setAuthToken(false);
  // Set current user to empty object {} which will set isAuthenticated to false
  dispatch(setCurrentUser({}));
};



// WEBPACK FOOTER //
// ./client/src/actions/AuthActions.js